import React from "react";
import { Container } from "reactstrap";
// used for making the prop types of this component
import PropTypes from "prop-types";
import './NavMenu.css';

class Footer extends React.Component {
    render() {
        return (
            <footer
                className={"footer" + (this.props.default ? " footer-default" : "")}
            >
                <Container fluid={this.props.fluid ? true : false}>
                    <p style={{
                        color: "#A9A9A9",
                        textAlign: "center",
                        fontSize: '0.65em',
                        background: '#233364'
                    }}>
                        Escuela Superior Polit&eacute;cnica del Litoral - Campus Gustavo Galindo - Guayaquil - Ecuador
                        <br />
                        &#169; El contenido de esta obra es de propiedad de la ESPOL. Todos los derechos reservados.
                        <br />
                        Prohibida su reproducci&oacute;n total o parcial, comunicaci&oacute;n p&uacute;blica o distribuci&oacute;n sin autorizaci&oacute;n previa del titular de los derechos.
                    </p>
                </Container>
            </footer>
        );
    }
}

Footer.propTypes = {
    default: PropTypes.bool,
    fluid: PropTypes.bool,
};

export default Footer;
